<div
  class="manager-dialog"
  *transloco="let t; prefix: 'CART.MANAGER_DIALOG'"
  dataAttribute
  componentName="manager-contact-dialog"
>
  <div class="manager-dialog__header">
    <h1
      class="manager-dialog__title"
      dataAttribute
      componentName="manager-contact-dialog-title"
    >
      {{ t('TITLE') }}
    </h1>

    <p-button
      text
      rounded
      icon="pi pi-times"
      dialog-close
      styleClass="color--primary"
      dataAttribute
      componentName="manager-contact-dialog-close-icon"
    ></p-button>
  </div>

  <div class="manager-dialog__body">
    @if (managerName) {
      <p
        class="manager-dialog__row"
        dataAttribute
        componentName="manager-contact-dialog-name"
      >
        {{ t('MANAGER_NAME', { name: managerName }) }}
      </p>
    }

    @if (warehouseAddress) {
      <p
        class="manager-dialog__row"
        dataAttribute
        componentName="manager-contact-dialog-warehouse-address"
      >
        {{ t('WAREHOUSE_ADDRESS', { address: warehouseAddress }) }}
      </p>
    }

    @for (phone of warehousePhones; track phone.value) {
      <p
        class="manager-dialog__row"
        dataAttribute
        componentName="manager-contact-dialog-warehouse-phone"
      >
        @if (phone.rawLabel) {
          {{ phone.rawLabel }}: {{ phone.value }}
        } @else {
          {{ t('WAREHOUSE_PHONE', { phone: phone.value }) }}
        }
      </p>
    }

    @if (managerPhone) {
      <p
        class="manager-dialog__row"
        dataAttribute
        componentName="manager-contact-dialog-phone"
      >
        {{ t('PHONE', { phone: managerPhone }) }}
      </p>
    } @else if (!warehousePhones.length) {
      @for (contact of defaultContacts; track contact.value) {
        <p
          class="manager-dialog__row"
          dataAttribute
          componentName="manager-contact-dialog-default-phone"
        >
          {{ contact.labelKey | transloco }}: {{ contact.value }}
        </p>
      }
    }
  </div>

  <div class="manager-dialog__footer">
    <p-button
      [label]="t('CLOSE')"
      size="large"
      dialog-close
      class="manager-dialog__close-button"
      styleClass="manager-dialog__close-inner"
      dataAttribute
      componentName="manager-contact-dialog-close-button"
    ></p-button>
  </div>
</div>
